import { render, staticRenderFns } from "./CollectionImageCreateScreen.vue?vue&type=template&id=6a690b21&"
import script from "./CollectionImageCreateScreen.vue?vue&type=script&lang=js&"
export * from "./CollectionImageCreateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports